import React, {Component} from 'react';
import {Link} from "react-router-dom";
import { Badge } from 'reactstrap';

class ListNotiAdminComponent extends Component {

    checkedNoti = (e) => {
        if ( e.nativeEvent.shiftKey ) {
            let value = e.target.checked;
            console.log('shiftKey');
            this.props.checkedNotiAdminShiftKey( this.props.actionKey, value );
        } else {
            this.props.checkedNotiAdmin( this.props.actionKey );
        }
    }

    render() {
        return (
            <tr>
                <td>
                    <input 
                        type="checkbox" 
                        checked={ this.props.noti.checked } 
                        onChange={ this.checkedNoti } 
                    />
                </td>
                <td>
                    <Link to={"/admin/noti-admin/detail/" + this.props.noti.id }>
                        { this.props.noti.created_at }
                    </Link>
                </td>
                <td className="text-left pl-4">
                    <Link to={"/admin/noti-admin/detail/" + this.props.noti.id }>
                        {
                            this.props.noti.title
                        }
                        {
                            !this.props.noti.read_at ? (
                                <Badge className="ml-2" color="secondary">
                                    Mới
                                </Badge>
                            ) : (
                                <></>
                            )
                        }
                    </Link>
                </td>
            </tr>
        );
    }
}

export default ListNotiAdminComponent;